import React, { useState, useEffect, useRef } from 'react';
import { Upload, Search, ChevronLeft, ChevronRight, FileSpreadsheet, CheckCircle, AlertTriangle, Sparkles, Bot, Send, Loader2, X, FileText, ChevronDown, ChevronUp, Zap, Droplets, Fuel, Layers, ArrowRight, Scale, LayoutDashboard, PieChart, Leaf, ShieldCheck, TrendingUp, Wallet, Activity, Factory, BarChart2,  Landmark, ArrowUpRight, ArrowDownRight, Percent, DollarSign, Clock, AlertOctagon, Target, Briefcase, Columns, Table2, Info, HelpCircle, Truck, Wrench, Recycle, ShoppingBag, Printer, Building2, MapPin, Users, Globe, Hash, Calculator, ShieldAlert, Siren, Lock, Banknote, ListFilter, Edit3, Save } from 'lucide-react';

// --- API AYARLARI ---
const apiKey = ""; // API anahtarı

// --- YARDIMCI FONKSİYONLAR ---
const normalizeString = (str) => {
  if (!str) return "";
  return str.replace(/Ğ/g, "g").replace(/ğ/g, "g").replace(/Ü/g, "u").replace(/ü/g, "u").replace(/Ş/g, "s").replace(/ş/g, "s").replace(/İ/g, "i").replace(/ı/g, "i").replace(/Ö/g, "o").replace(/ö/g, "o").replace(/Ç/g, "c").replace(/ç/g, "c").replace(/[^a-zA-Z0-9]/g, " ").toLowerCase().trim();
};

const formatCurrency = (value) => {
    const val = typeof value === 'number' ? value : 0;
    return val.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const formatPercent = (value) => {
     const val = typeof value === 'number' ? value : 0;
     return `%${(val * 100).toFixed(1)}`;
};

// --- SABİT DEĞERLER ---
// Kapsam ve Faktör Veritabanı (Genişletilmiş Anahtar Kelimeler)
const SUSTAINABILITY_CATEGORIES = [
    { id: 'electricity', label: 'Elektrik Enerjisi', scope: 'Kapsam 2', keywords: ['elektrik', 'enerji', 'edas', 'ck', 'tedas', 'epdk', 'enerjisa', 'aydem', 'gediz', 'uludag', 'akdeniz', 'toroslar'], icon: Zap, color: 'text-yellow-600', bg: 'bg-yellow-50', factor: 0.442, unit: 'kgCO2e/TL', desc: 'Şebeke elektriği tüketimi (Türkiye Ortalaması).' },
    { id: 'heating', label: 'Isınma & Doğalgaz', scope: 'Kapsam 1', keywords: ['dogalgaz', 'isinma', 'yakit', 'igdas', 'baskentgaz', 'izgaz', 'komur', 'fueloil', 'kazan', 'kalorifer'], icon: Layers, color: 'text-orange-600', bg: 'bg-orange-50', factor: 0.220, unit: 'kgCO2e/TL', desc: 'Isınma amaçlı doğalgaz ve yakıt kullanımı.' },
    { id: 'fuel', label: 'Araç Yakıtı (Dizel/Benzin)', scope: 'Kapsam 1', keywords: ['akaryakit', 'motorin', 'benzin', 'petrol', 'shell', 'opet', 'bp', 'total', 'mazot', 'tasit tanima', 'ulasim yakit'], icon: Truck, color: 'text-red-600', bg: 'bg-red-50', factor: 2.680, unit: 'kgCO2e/TL', desc: 'Şirket araçları ve jeneratör yakıt tüketimi.' },
    { id: 'water', label: 'Su Tüketimi', scope: 'Kapsam 3', keywords: ['su ', 'iski', 'aski', 'buski', 'izsu', 'sebeke suyu', 'damacana', 'saka', 'erikli'], icon: Droplets, color: 'text-blue-600', bg: 'bg-blue-50', factor: 0.344, unit: 'kgCO2e/TL', desc: 'Şebeke suyu kullanımı ve arıtma.' },
    { id: 'logistics', label: 'Lojistik & Kargo', scope: 'Kapsam 3', keywords: ['kargo', 'nakliye', 'tasima', 'ulasim', 'lojistik', 'yurtici', 'aras', 'mng', 'ups', 'dhl', 'fedex'], icon: Truck, color: 'text-indigo-600', bg: 'bg-indigo-50', factor: 0.280, unit: 'kgCO2e/TL', desc: 'Dış kaynaklı lojistik ve kargo hizmetleri.' },
    { id: 'travel', label: 'İş Seyahatleri', scope: 'Kapsam 3', keywords: ['seyahat', 'ucak', 'otel', 'konaklama', 'bilet', 'thy', 'pegasus', 'taksi'], icon: Globe, color: 'text-sky-600', bg: 'bg-sky-50', factor: 0.150, unit: 'kgCO2e/TL', desc: 'Personel iş seyahatleri ve konaklama.' },
    { id: 'supplier', label: 'Dış Hizmet & Tedarik', scope: 'Kapsam 3', keywords: ['danismanlik', 'musavirlik', 'yemek', 'guvenlik', 'temizlik', 'hizmet', 'aidat', 'kira', 'taseron', 'noter'], icon: ShoppingBag, color: 'text-pink-600', bg: 'bg-pink-50', factor: 0.050, unit: 'kgCO2e/TL', desc: 'Satın alınan operasyonel hizmetler.' },
    { id: 'maintenance', label: 'Bakım & Onarım', scope: 'Kapsam 3', keywords: ['bakim', 'onarim', 'tamir', 'servis', 'yedek parca', 'lastik', 'sanayi'], icon: Wrench, color: 'text-slate-600', bg: 'bg-slate-100', factor: 0.120, unit: 'kgCO2e/TL', desc: 'Araç ve makine bakım onarım faaliyetleri.' },
    { id: 'waste', label: 'Sarf Malzeme & Kağıt', scope: 'Kapsam 3', keywords: ['kirtasiye', 'sarf', 'matbu', 'ambalaj', 'kagit', 'toner', 'baski'], icon: Recycle, color: 'text-green-600', bg: 'bg-green-100', factor: 0.150, unit: 'kgCO2e/TL', desc: 'Kağıt, kırtasiye ve ambalaj tüketimi.' },
    { id: 'digital', label: 'Dijital Hizmetler', scope: 'Kapsam 3', keywords: ['internet', 'yazilim', 'lisans', 'telekom', 'turkcell', 'vodafone', 'turk telekom', 'hosting', 'bulut'], icon: MapPin, color: 'text-purple-600', bg: 'bg-purple-50', factor: 0.010, unit: 'kgCO2e/TL', desc: 'Dijital altyapı ve iletişim hizmetleri.' },
];

const EMISSION_FACTORS = { electricity: 0.442, heating: 0.22, fuel: 2.68, water: 0.34 }; 

// --- GÖRSEL BİLEŞENLER ---
const GaugeChart = ({ value, min = 0, max = 100, label, subLabel, color }) => {
  const safeValue = typeof value === 'number' ? value : 0;
  const percentage = Math.min(Math.max((safeValue - min) / (max - min), 0), 1);
  const angle = percentage * 180;
  return (
    <div className="relative w-32 h-20 overflow-hidden flex justify-center group">
      <div className="absolute top-4 w-24 h-24 rounded-full border-[8px] border-slate-100 box-border"></div>
      <div className="absolute top-4 w-24 h-24 rounded-full border-[8px] border-transparent border-t-current box-border transition-all duration-1000 ease-out" style={{ transform: `rotate(${angle - 45}deg)`, borderColor: 'transparent transparent transparent', borderTopColor: color }}></div>
      <div className="absolute bottom-0 text-center w-full">
        <span className="text-xl font-bold text-slate-700 block">{safeValue.toFixed(1)}</span>
         <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">{label}</span>
      </div>
    </div>
  );
};

const RiskGauge = ({ val, min, max, title, unit }) => {
    const safeVal = typeof val === 'number' ? val : 0;
    const p = Math.min(Math.max((safeVal - min) / (max - min), 0), 1) * 100;
    let color = 'bg-emerald-500';
    if(p > 70) color = 'bg-rose-500'; else if(p > 40) color = 'bg-amber-500';
    return (
        <div className="flex flex-col gap-1">
            <div className="flex justify-between text-xs font-bold text-slate-500"><span>{title}</span><span>{safeVal.toFixed(1)}{unit}</span></div>
            <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden"><div className={`h-full ${color} rounded-full transition-all duration-1000`} style={{width: `${p}%`}}></div></div>
        </div>
    )
  };

const KpiCard = ({ title, value, unit = "", subText, status, type = "neutral", formula, explanation }) => {
    let colorClass = "text-slate-700";
    let bgClass = "bg-white";
    let icon = <Activity size={20} className="text-slate-400" />;

    if (type === "good") { colorClass = "text-emerald-600"; bgClass = "bg-emerald-50"; icon = <TrendingUp size={20} className="text-emerald-600"/>; }
    if (type === "warning") { colorClass = "text-amber-600"; bgClass = "bg-amber-50"; icon = <AlertOctagon size={20} className="text-amber-600"/>; }
    if (type === "bad") { colorClass = "text-rose-600"; bgClass = "bg-rose-50"; icon = <ArrowDownRight size={20} className="text-rose-600"/>; }

    return (
        <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-all relative overflow-visible group">
            <div className="absolute top-2 right-2 z-10 no-print">
                <div className="group/info relative">
                    <HelpCircle size={14} className="text-slate-300 hover:text-indigo-500 cursor-help" />
                    <div className="absolute right-0 bottom-full mb-2 w-48 p-2 bg-slate-800 text-white text-[10px] rounded shadow-xl opacity-0 group-hover/info:opacity-100 transition-opacity pointer-events-none z-20">
                        <div className="font-bold mb-1 text-indigo-300">Formül:</div>
                        <div className="font-mono text-slate-300 mb-1">{formula}</div>
                    </div>
                </div>
            </div>
            <div className="mt-1">
                <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block mb-1">{title}</span>
                <div className="flex items-baseline gap-1">
                    <h3 className={`text-xl font-black tracking-tight ${colorClass}`}>{value}</h3>
                    <span className="text-[10px] font-medium text-slate-400">{unit}</span>
                </div>
            </div>
            <div className="mt-2 pt-2 border-t border-slate-50">
                 <div className={`text-[10px] p-1.5 rounded leading-snug font-medium ${type === 'good' ? 'bg-emerald-50 text-emerald-700' : type === 'warning' ? 'bg-amber-50 text-amber-700' : 'bg-rose-50 text-rose-700'}`}>
                    {explanation}
                 </div>
            </div>
        </div>
    );
  };

const App = () => {
  // --- STATE YÖNETİMİ ---
  const [activeTab, setActiveTab] = useState('upload'); 
  const [mizanData, setMizanData] = useState([]);
  const [groupedData, setGroupedData] = useState([]);
  const [reportData, setReportData] = useState(null);
  const [expenseInventory, setExpenseInventory] = useState([]); 
  const [manualMatches, setManualMatches] = useState({}); // Yeni State: Manuel Eşleşmeler { '740.01': 'electricity' }
  const [financialStatements, setFinancialStatements] = useState(null);
  
  const [activeStatement, setActiveStatement] = useState('balance');
  const [fileName, setFileName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedRows, setExpandedRows] = useState({});
  
  const [aiReport, setAiReport] = useState("");
  const [isAiGenerating, setIsAiGenerating] = useState(false);
  const [showChat, setShowChat] = useState(false);
  const [chatMessage, setChatMessage] = useState("");
  const [chatHistory, setChatHistory] = useState([{ role: 'model', text: 'Merhaba! Ben Entegre Rapor Asistanınızım.' }]);
  const [isChatLoading, setIsChatLoading] = useState(false);
  const chatEndRef = useRef(null);
  const reportGeneratedRef = useRef(false); 


  // --- HESAPLAMA MOTORU ---
  useEffect(() => {
    if (mizanData.length === 0) return;

    // 1. Gruplama Mantığı
    const sortedData = [...mizanData].sort((a, b) => a.hesapKodu.localeCompare(b.hesapKodu));
    const groups = [];
    let currentMainGroup = null;

    sortedData.forEach(item => {
        const code = item.hesapKodu;
        const isMainAccount = code.length === 3 && !code.includes('.');
        if (isMainAccount) {
            currentMainGroup = { ...item, subItems: [] };
            groups.push(currentMainGroup);
        } else {
            if (currentMainGroup && code.startsWith(currentMainGroup.hesapKodu)) {
                currentMainGroup.subItems.push(item);
            } else {
                groups.push({ ...item, subItems: [] });
            }
        }
    });
    setGroupedData(groups);

    // 2. Finansal Verilerin Hazırlanması
    let fin = {
        assets: { current: 0, fixed: 0, cash: 0, receivables: 0, inventory: 0, total: 0 },
        liabilities: { short: 0, long: 0, bankLoansShort: 0, bankLoansLong: 0, payables: 0, total: 0 },
        equity: 0,
        income: { gross: 0, net: 0 },
        cogs: 0, 
        expenses: { operating: 0, finance: 0, total: 0 }, 
        profit: { gross: 0, operating: 0, net: 0, ebitda: 0 } 
    };

    let bs = { currentAssets: 0, fixedAssets: 0, shortLiab: 0, longLiab: 0, equity: 0 };
    let is = { grossSales: 0, salesDeductions: 0, cogs: 0, operatingExp: 0, otherIncome: 0, otherExp: 0, financeExp: 0, extraordinaryIncome: 0, extraordinaryExpense: 0 };

    const isLeafNode = (code) => {
        return !mizanData.some(item => item.hesapKodu !== code && item.hesapKodu.startsWith(code + '.'));
    };

    // 3. Detaylı Gider ve Emisyon Analizi (740-789 Arası)
    let detailedExpenses = [];
    let susData = { total_emission: 0 };
    SUSTAINABILITY_CATEGORIES.forEach(cat => susData[cat.id] = 0);
    susData.other = 0; 

    mizanData.forEach(item => {
        const code = item.hesapKodu;
        const netBorcBakiye = item.borc - item.alacak; 
        const netAlacakBakiye = item.alacak - item.borc;
        const giderTutari = item.borc; 

        // Finansal Tablolar Mantığı
        if (code.length === 3 && !code.includes('.')) {
            // AKTİF
            if (code.startsWith('1')) { 
                const val = netBorcBakiye; 
                fin.assets.current += val; bs.currentAssets += val; 
                if (['100','101','102','108'].includes(code)) fin.assets.cash += val;
                if (['120','121'].includes(code)) fin.assets.receivables += val;
                if (code.startsWith('15')) fin.assets.inventory += val;
            }
            if (code.startsWith('2')) { 
                const val = netBorcBakiye; 
                fin.assets.fixed += val; bs.fixedAssets += val; 
            }
            if (code.startsWith('3')) { 
                const val = netAlacakBakiye;
                fin.liabilities.short += val; bs.shortLiab += val; 
                if(code === '300') fin.liabilities.bankLoansShort += val;
                if(['320','321'].includes(code)) fin.liabilities.payables += val;
            }
            if (code.startsWith('4')) { 
                const val = netAlacakBakiye;
                fin.liabilities.long += val; bs.longLiab += val; 
                 if(code === '400') fin.liabilities.bankLoansLong += val;
            }
            if (code.startsWith('5')) { 
                const val = netAlacakBakiye;
                fin.equity += val; bs.equity += val; 
            }

            if (code.startsWith('60')) { is.grossSales += netAlacakBakiye; fin.income.gross += netAlacakBakiye; }
            if (code.startsWith('61')) is.salesDeductions += netBorcBakiye;
            if (code.startsWith('62')) { is.cogs += netBorcBakiye; fin.cogs += netBorcBakiye; }
            if (['710', '720', '730', '740'].includes(code)) { is.cogs += netBorcBakiye; fin.cogs += netBorcBakiye; }

            if (code.startsWith('63')) { is.operatingExp += netBorcBakiye; fin.expenses.operating += netBorcBakiye; }
            if (['750', '760', '770'].includes(code)) { is.operatingExp += netBorcBakiye; fin.expenses.operating += netBorcBakiye; }

            if (code.startsWith('64')) is.otherIncome += netAlacakBakiye;
            if (code.startsWith('65')) is.otherExp += netBorcBakiye;

            if (code.startsWith('66')) { is.financeExp += netBorcBakiye; fin.expenses.finance += netBorcBakiye; }
            if (code === '780') { is.financeExp += netBorcBakiye; fin.expenses.finance += netBorcBakiye; }

            if (code.startsWith('67')) is.extraordinaryIncome += netAlacakBakiye;
            if (code.startsWith('68')) is.extraordinaryExpense += netBorcBakiye;

            if (code.startsWith('7')) fin.expenses.total += giderTutari; 
        }

        // SÜRDÜRÜLEBİLİRLİK VE GİDER ENVANTERİ
        const expensePrefixes = ['74', '75', '76', '77', '78'];
        if (expensePrefixes.some(prefix => code.startsWith(prefix)) && isLeafNode(code) && giderTutari > 0) {
            const normalizedDesc = normalizeString(item.hesapAdi);
            let matchFound = false;
            let matchedCategory = null;
            let isManual = false;

            // 1. Önce Manuel Eşleşme Kontrolü
            if (manualMatches[code]) {
                const manualCatId = manualMatches[code];
                matchedCategory = SUSTAINABILITY_CATEGORIES.find(c => c.id === manualCatId);
                if (matchedCategory) {
                    matchFound = true;
                    isManual = true;
                }
            }

            // 2. Eğer Manuel Yoksa, Otomatik Eşleşme Dene
            if (!matchFound) {
                for (const cat of SUSTAINABILITY_CATEGORIES) {
                    if (cat.keywords.some(k => normalizedDesc.includes(k))) {
                        matchedCategory = cat;
                        matchFound = true;
                        break;
                    }
                }
            }

            // Toplamları Güncelle
            if (matchFound && matchedCategory) {
                if (susData[matchedCategory.id] !== undefined) {
                    susData[matchedCategory.id] += giderTutari;
                    susData.total_emission += (giderTutari * matchedCategory.factor);
                }
            } else {
                 susData.other += giderTutari;
            }

            // Envanter Listesine Ekle
            detailedExpenses.push({
                code: item.hesapKodu,
                name: item.hesapAdi,
                amount: giderTutari,
                category: matchFound ? matchedCategory.label : 'Eşleşme Yok',
                categoryId: matchFound ? matchedCategory.id : null, // Dropdown seçimi için
                scope: matchFound ? matchedCategory.scope : 'Kapsam Dışı',
                factor: matchFound ? matchedCategory.factor : 0,
                calculatedEmission: matchFound ? (giderTutari * matchedCategory.factor) : 0,
                isMatched: matchFound,
                isManual: isManual,
                icon: matchFound ? matchedCategory.icon : null
            });
        }
    });

    // Finansal Hesaplamalar Tamamlama
    fin.assets.total = fin.assets.current + fin.assets.fixed;
    fin.liabilities.total = fin.liabilities.short + fin.liabilities.long;

    const netSales = is.grossSales - is.salesDeductions;
    fin.income.net = netSales;
    const grossProfit = netSales - is.cogs;
    fin.profit.gross = grossProfit;
    const operatingProfit = grossProfit - is.operatingExp;
    fin.profit.operating = operatingProfit;
    
    const profitBeforeTax = operatingProfit + is.otherIncome - is.otherExp - is.financeExp + is.extraordinaryIncome - is.extraordinaryExpense;
    fin.profit.net = profitBeforeTax; 
    fin.profit.ebitda = operatingProfit; 

    const calculatedProfit = profitBeforeTax; 
    const totalEquity = bs.equity + calculatedProfit;

    setFinancialStatements({
        totals: {
            currentAssets: bs.currentAssets,
            fixedAssets: bs.fixedAssets,
            totalAssets: bs.currentAssets + bs.fixedAssets,
            shortLiab: bs.shortLiab,
            longLiab: bs.longLiab,
            equity: totalEquity,
            totalLiabilitiesAndEquity: bs.shortLiab + bs.longLiab + totalEquity,
            calculatedProfit
        },
        incomeStatement: { ...is, netSales, grossProfit, operatingProfit, profitBeforeTax }
    });

    const ratios = {
        currentRatio: fin.liabilities.short > 0 ? fin.assets.current / fin.liabilities.short : 0,
        acidTest: fin.liabilities.short > 0 ? (fin.assets.current - fin.assets.inventory) / fin.liabilities.short : 0,
        cashRatio: fin.liabilities.short > 0 ? fin.assets.cash / fin.liabilities.short : 0,
        nwc: fin.assets.current - fin.liabilities.short, 
        leverage: fin.assets.total > 0 ? fin.liabilities.total / fin.assets.total : 0, 
        debtToEquity: totalEquity > 0 ? fin.liabilities.total / totalEquity : 0,
        equityRatio: fin.assets.total > 0 ? totalEquity / fin.assets.total : 0,
        shortTermDebtRate: fin.liabilities.total > 0 ? fin.liabilities.short / fin.liabilities.total : 0,
        grossMargin: netSales > 0 ? grossProfit / netSales : 0,
        operatingMargin: netSales > 0 ? operatingProfit / netSales : 0,
        netMargin: netSales > 0 ? profitBeforeTax / netSales : 0,
        ebitdaMargin: netSales > 0 ? fin.profit.ebitda / netSales : 0,
        roe: totalEquity > 0 ? profitBeforeTax / totalEquity : 0,
        dso: netSales > 0 ? (fin.assets.receivables / netSales) * 360 : 0, 
        dio: is.cogs > 0 ? (fin.assets.inventory / is.cogs) * 360 : 0, 
        dpo: is.cogs > 0 ? (fin.liabilities.payables / is.cogs) * 360 : 0, 
    };
    ratios.ccc = ratios.dso + ratios.dio - ratios.dpo;

    let score = 0;
    if (ratios.currentRatio >= 1.2) score += 15;
    if (ratios.leverage <= 0.7) score += 15;
    if (ratios.netMargin > 0.05) score += 20;
    if (ratios.roe > 0.15) score += 15;
    if (ratios.ccc < 90) score += 15;
    if (ratios.operatingMargin > 0) score += 20;
    
    const risks = {
        liquidity: ratios.currentRatio < 1.0 ? "Yüksek" : ratios.currentRatio < 1.5 ? "Orta" : "Düşük",
        credit: ratios.leverage > 0.8 ? "Yüksek" : ratios.leverage > 0.6 ? "Orta" : "Düşük",
        profitability: ratios.netMargin < 0 ? "Yüksek" : ratios.netMargin < 0.05 ? "Orta" : "Düşük",
        efficiency: ratios.ccc > 120 ? "Yüksek" : "Düşük"
    };

    const carbon = {
        scope1: (susData.heating * EMISSION_FACTORS.heating) + (susData.fuel * EMISSION_FACTORS.fuel),
        scope2: (susData.electricity * EMISSION_FACTORS.electricity),
        scope3: susData.total_emission - ((susData.heating * EMISSION_FACTORS.heating) + (susData.fuel * EMISSION_FACTORS.fuel) + (susData.electricity * EMISSION_FACTORS.electricity))
    };
    carbon.total = susData.total_emission;

    let operationalScore = 75; 
    if (susData.total_emission > 0 && netSales > 0) {
        const intensity = susData.total_emission / netSales; 
        operationalScore = Math.max(10, 100 - (intensity * 200)); 
    } else if (susData.total_emission > 0) {
        operationalScore = 50; 
    } else {
        operationalScore = 0; 
    }

    setReportData({ financials: fin, sustainability: susData, ratios, score, risks, carbonFootprint: carbon, operationalScore });
    setExpenseInventory(detailedExpenses.sort((a,b) => a.code.localeCompare(b.code)));

  }, [mizanData, manualMatches]); // manualMatches eklendi

  // --- AI ---
  const callGemini = async (prompt) => {
    try {
      const response = await fetch(
        `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-preview-09-2025:generateContent?key=${apiKey}`,
        { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ contents: [{ parts: [{ text: prompt }] }] }) }
      );
      const data = await response.json();
      return data.candidates?.[0]?.content?.parts?.[0]?.text || "Hata oluştu.";
    } catch (error) { return "Bağlantı hatası."; }
  };

  const generateAIReport = async () => {
    if (!reportData) return;
    setIsAiGenerating(true);
    const prompt = `Sen uzman bir sürdürülebilirlik danışmanısın. KOBİ verilerini analiz et ve "Yönetici Özeti" başlığı altında çok kısa, net ve stratejik bir özet yaz.
    
    VERİLER:
    - Finansal Skor: ${reportData.score}/100
    - Likidite Riski: ${reportData.risks.liquidity} (Cari Oran: ${reportData.ratios.currentRatio.toFixed(2)})
    - Karbon Ayak İzi: ${reportData.totalEmission?.toFixed(0)} kgCO2e
    
    ÇIKTI FORMATI (Markdown):
    1 paragraf genel değerlendirme, 3 adet nokta atışı aksiyon önerisi.`;
    
    const text = await callGemini(prompt);
    setAiReport(text);
    setIsAiGenerating(false);
  };

  useEffect(() => {
      if (reportData && activeTab === 'report' && !reportGeneratedRef.current) {
          generateAIReport();
          reportGeneratedRef.current = true;
      }
  }, [reportData, activeTab]);

  const handleChat = async () => {
    if (!chatMessage.trim()) return;
    const userMsg = { role: 'user', text: chatMessage };
    setChatHistory(prev => [...prev, userMsg]);
    setChatMessage("");
    setIsChatLoading(true);
    const response = await callGemini(chatMessage);
    setChatHistory(prev => [...prev, { role: 'model', text: response }]);
    setIsChatLoading(false);
  };

  const handleManualMatch = (code, categoryId) => {
      setManualMatches(prev => ({
          ...prev,
          [code]: categoryId
      }));
  };

  // --- GLOBAL PRINT ---
  const handlePrint = () => {
    window.print();
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);
      setIsLoading(true);
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const text = e.target.result;
          const rows = text.split('\n');
          const processedData = [];
          const delimiter = rows[0].includes(';') ? ';' : ',';
          for (let i = 0; i < rows.length; i++) {
            const cols = rows[i].split(delimiter);
            const clean = (v) => v ? v.replace(/["\r]/g, '').trim() : '';
            const parseMoney = (v) => {
                if (!v) return 0;
                let val = clean(v);
                if (val.includes(',') && val.includes('.')) val = val.replace(/\./g, '').replace(',', '.');
                else if (val.includes(',')) val = val.replace(',', '.');
                val = val.replace(/[^0-9.-]/g, '');
                return parseFloat(val) || 0;
            };
            const col0 = clean(cols[0]);
            if (/^[0-9\.]{3,}$/.test(col0)) {
                const borc = parseMoney(cols[2]);
                const alacak = parseMoney(cols[3]);
                processedData.push({ 
                    id: i, 
                    hesapKodu: col0, 
                    hesapAdi: clean(cols[1]), 
                    borc, 
                    alacak, 
                    borcBakiyesi: Math.max(0, borc - alacak), 
                    alacakBakiyesi: Math.max(0, alacak - borc) 
                });
            }
          }
          if (processedData.length > 0) { setMizanData(processedData); setActiveTab('mizan'); } 
          else { alert("Veri okunamadı."); }
        } catch (err) { alert("Hata."); } finally { setIsLoading(false); }
      };
      reader.readAsText(file, "ISO-8859-9");
    }
  };

  // --- SAYFALAR ---
  const MizanView = () => {
      // ... Mizan view logic same as before ...
      const totalBorcBakiyesi = groupedData.reduce((acc, item) => acc + item.borcBakiyesi, 0);
      const totalAlacakBakiyesi = groupedData.reduce((acc, item) => acc + item.alacakBakiyesi, 0);
      const netFark = totalBorcBakiyesi - totalAlacakBakiyesi;
      let totalAktif = 0; let totalPasif = 0;
      groupedData.forEach(group => {
          const code = parseInt(group.hesapKodu.substring(0, 3));
          if (isNaN(code)) return;
          if (code >= 100 && code <= 299) { totalAktif += (group.borcBakiyesi - group.alacakBakiyesi); }
          else if (code >= 300 && code <= 799) { totalPasif += (group.alacakBakiyesi - group.borcBakiyesi); }
      });
      const bilançoFarki = totalAktif - totalPasif;
      const isBalanced = Math.abs(bilançoFarki) < 1.0; 
      return (
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col h-[700px] animate-in fade-in print:h-auto print:shadow-none print:border-none">
          <div className="p-4 border-b border-slate-100 flex justify-between items-center bg-slate-50 no-print">
              <h3 className="font-bold text-slate-700 flex items-center gap-2"><FileText size={18}/> Mizan Görüntüleme</h3>
              <div className="flex gap-2">
                  <button onClick={handlePrint} className="p-2 bg-slate-200 rounded hover:bg-slate-300 text-slate-600"><Printer size={18}/></button>
                  <div className="relative w-64"><Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"/><input type="text" placeholder="Hesap Ara..." className="w-full pl-9 pr-4 py-2 border rounded-lg text-sm outline-none focus:ring-2 focus:ring-indigo-500" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}/></div>
              </div>
          </div>
          <div className="flex-1 overflow-y-auto print:overflow-visible">
              <table className="w-full text-left text-sm">
                  <thead className="bg-white text-slate-600 sticky top-0 z-10 shadow-sm font-semibold print:static"><tr><th className="p-3 w-10"></th><th className="p-3">Kod</th><th className="p-3">Hesap Adı</th><th className="p-3 text-right">Borç</th><th className="p-3 text-right">Alacak</th><th className="p-3 text-right">Bakiye</th></tr></thead>
                  <tbody className="divide-y divide-slate-100">
                      {groupedData.filter(g => normalizeString(g.hesapAdi).includes(normalizeString(searchTerm)) || g.hesapKodu.includes(searchTerm)).map(group => (
                          <React.Fragment key={group.hesapKodu}>
                              <tr className="hover:bg-slate-50 font-medium cursor-pointer bg-slate-50/30" onClick={() => setExpandedRows(p => ({...p, [group.hesapKodu]: !p[group.hesapKodu]}))}>
                                  <td className="p-3 text-center text-slate-400 no-print">{group.subItems.length > 0 && (expandedRows[group.hesapKodu] ? <ChevronUp size={14}/> : <ChevronDown size={14}/>)}</td>
                                  <td className="p-3 font-mono text-slate-700">{group.hesapKodu}</td><td className="p-3 text-slate-800">{group.hesapAdi}</td><td className="p-3 text-right text-slate-500">{formatCurrency(group.borc)}</td><td className="p-3 text-right text-slate-500">{formatCurrency(group.alacak)}</td><td className={`p-3 text-right font-bold ${(group.borc - group.alacak) > 0 ? 'text-indigo-600' : (group.borc - group.alacak) < 0 ? 'text-orange-600' : 'text-slate-400'}`}>{formatCurrency(group.borc - group.alacak)}</td>
                              </tr>
                              {(expandedRows[group.hesapKodu] || window.matchMedia('print').matches) && group.subItems.map(sub => (
                                  <tr key={sub.id} className="bg-white text-xs text-slate-500 hover:bg-yellow-50 transition-colors"><td></td><td className="p-2 pl-8 font-mono">{sub.hesapKodu}</td><td className="p-2">{sub.hesapAdi}</td><td className="p-2 text-right">{formatCurrency(sub.borc)}</td><td className="p-2 text-right">{formatCurrency(sub.alacak)}</td><td className="p-2 text-right font-medium text-slate-700">{formatCurrency(sub.borc - sub.alacak)}</td></tr>
                              ))}
                          </React.Fragment>
                      ))}
                  </tbody>
                  <tfoot className="bg-slate-100 font-bold text-slate-800 sticky bottom-0 border-t-2 border-slate-300 z-20 print:static"><tr><td colSpan="3" className="p-4 text-right text-xs uppercase tracking-wider text-slate-500">GENEL TOPLAM (BAKİYELER):</td><td className="p-4 text-right text-green-700 text-lg">{formatCurrency(totalBorcBakiyesi)}</td><td className="p-4 text-right text-red-700 text-lg">{formatCurrency(totalAlacakBakiyesi)}</td><td className="p-4 text-right text-blue-700">{formatCurrency(Math.abs(netFark))}</td></tr></tfoot>
              </table>
          </div>
          <div className="bg-white border-t border-slate-200 p-4 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]">
              <div className="flex items-center justify-between gap-8">
                  <div className={`flex items-center gap-3 px-4 py-2 rounded-lg border ${isBalanced ? 'bg-emerald-50 border-emerald-200 text-emerald-800' : 'bg-rose-50 border-rose-200 text-rose-800'}`}>{isBalanced ? <CheckCircle size={20} /> : <AlertTriangle size={20} />}<div><p className="text-xs font-bold uppercase tracking-wider">Bilanço Dengesi</p><p className="font-semibold">{isBalanced ? 'EŞİT (DENGEDE)' : 'FARK VAR'}</p></div></div>
                  <div className="flex gap-8"><div className="text-right"><p className="text-xs text-slate-400 uppercase font-bold mb-1">AKTİF TOPLAMI (100-299)</p><p className="text-2xl font-bold text-green-700 font-mono">{formatCurrency(totalAktif)} TL</p></div><div className="w-px bg-slate-200"></div><div className="text-right"><p className="text-xs text-slate-400 uppercase font-bold mb-1">PASİF TOPLAMI (300-799)</p><p className="text-2xl font-bold text-red-700 font-mono">{formatCurrency(totalPasif)} TL</p></div></div>
                  {!isBalanced && (<div className="text-right bg-rose-50 p-2 rounded border border-rose-100"><p className="text-xs text-rose-500 uppercase font-bold">FARK</p><p className="font-bold text-rose-700">{formatCurrency(bilançoFarki)}</p></div>)}
              </div>
          </div>
      </div>
    )};

  const StatementsView = () => {
    // ... statements logic same as before ...
    if (!financialStatements) return <div className="p-10 text-center text-slate-500">Analiz için veri yükleyiniz.</div>;
    const { totals, incomeStatement } = financialStatements;
    const AccountDetailList = ({ prefix, type }) => {
        const accounts = groupedData.filter(g => g.hesapKodu.startsWith(prefix));
        if (accounts.length === 0) return null;
        return (
            <div className="pl-4 border-l-2 border-slate-100 ml-2 mb-2">
                {accounts.map(g => {
                    let val = 0;
                    if (type === 'asset') val = g.borc - g.alacak; else val = g.alacak - g.borc;
                    if (val === 0) return null; 
                    return (<div key={g.hesapKodu} className="flex justify-between text-xs py-1 border-b border-slate-50 hover:bg-slate-50"><div className="flex gap-2"><span className="font-mono text-slate-500 w-10">{g.hesapKodu}</span><span className="text-slate-700">{g.hesapAdi}</span></div><span className={`font-medium ${val < 0 ? 'text-red-500' : 'text-slate-700'}`}>{formatCurrency(val)}</span></div>)
                })}
            </div>
        );
    };
    const IncomeExpenseDetailList = ({ prefixes, type }) => {
        const accounts = groupedData.filter(g => prefixes.some(p => g.hesapKodu.startsWith(p)));
        if (accounts.length === 0) return null;
        return (
            <div className="pl-4 border-l-2 border-slate-100 ml-2 mb-2">
                {accounts.map(g => {
                    let val = 0;
                    if (type === 'income') val = g.alacak - g.borc; else val = g.borc - g.alacak;
                    if (val <= 0) return null; 
                    return (<div key={g.hesapKodu} className="flex justify-between text-xs py-1 border-b border-slate-50 hover:bg-slate-50"><div className="flex gap-2"><span className="font-mono text-slate-500 w-10">{g.hesapKodu}</span><span className="text-slate-700">{g.hesapAdi}</span></div><span className="font-medium text-slate-700">{formatCurrency(val)}</span></div>)
                })}
            </div>
        );
    };
    const Row = ({ label, value, bold = false, indent = false, color = "text-slate-700" }) => (<div className={`flex justify-between py-2 border-b border-slate-50 ${bold ? 'font-bold' : ''}`}><span className={`${indent ? 'pl-6 text-sm text-slate-500' : 'text-slate-800'}`}>{label}</span><span className={`${color}`}>{formatCurrency(value)}</span></div>);
    return (
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 h-[700px] overflow-y-auto animate-in fade-in print:h-auto print:overflow-visible">
            <div className="flex justify-center mb-6 no-print"><div className="bg-slate-100 p-1 rounded-lg flex gap-1"><button onClick={() => setActiveStatement('balance')} className={`px-4 py-2 rounded-md text-sm font-medium transition-all ${activeStatement === 'balance' ? 'bg-white shadow-sm text-indigo-600' : 'text-slate-500'}`}>Bilanço (Detaylı)</button><button onClick={() => setActiveStatement('income')} className={`px-4 py-2 rounded-md text-sm font-medium transition-all ${activeStatement === 'income' ? 'bg-white shadow-sm text-indigo-600' : 'text-slate-500'}`}>Gelir Tablosu (Detaylı)</button></div></div>
             <div className="flex justify-end mb-2 no-print"><button onClick={handlePrint} className="p-2 bg-slate-200 rounded hover:bg-slate-300 text-slate-600"><Printer size={18}/></button></div>

            {activeStatement === 'balance' ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 print:block">
                    <div className="border border-slate-200 rounded-xl overflow-hidden print:mb-4"><div className="bg-green-50 p-3 border-b border-green-100 font-bold text-green-800 text-center uppercase tracking-wide">AKTİF (VARLIKLAR)</div><div className="p-4 bg-white space-y-4"><div><Row label="I. DÖNEN VARLIKLAR" value={totals.currentAssets} bold /><AccountDetailList prefix="1" type="asset" /></div><div><Row label="II. DURAN VARLIKLAR" value={totals.fixedAssets} bold /><AccountDetailList prefix="2" type="asset" /></div><div className="mt-6 pt-4 border-t-2 border-green-100 bg-green-50/30 p-2 rounded"><Row label="AKTİF TOPLAMI" value={totals.totalAssets} bold color="text-green-700 text-lg" /></div></div></div>
                    <div className="border border-slate-200 rounded-xl overflow-hidden"><div className="bg-red-50 p-3 border-b border-red-100 font-bold text-red-800 text-center uppercase tracking-wide">PASİF (KAYNAKLAR)</div><div className="p-4 bg-white space-y-4"><div><Row label="III. KISA VADELİ KAYNAKLAR" value={totals.shortLiab} bold /><AccountDetailList prefix="3" type="liability" /></div><div><Row label="IV. UZUN VADELİ KAYNAKLAR" value={totals.longLiab} bold /><AccountDetailList prefix="4" type="liability" /></div><div><Row label="V. ÖZKAYNAKLAR" value={totals.equity} bold /><AccountDetailList prefix="5" type="liability" /><div className="pl-4 border-l-2 border-yellow-200 ml-2 mt-2"><div className="flex justify-between text-xs py-2 bg-orange-50 px-2 rounded border border-orange-200"><span className="text-orange-800 font-medium">Dönem Net Karı/Zararı (Gelir Tablosu Farkı)</span><span className={`font-bold ${totals.calculatedProfit > 0 ? 'text-green-700' : 'text-red-700'}`}>{formatCurrency(totals.calculatedProfit)}</span></div></div></div><div className="mt-6 pt-4 border-t-2 border-red-100 bg-red-50/30 p-2 rounded"><Row label="PASİF TOPLAMI" value={totals.totalLiabilitiesAndEquity} bold color="text-red-700 text-lg" /></div></div></div>
                </div>
            ) : (
                <div className="max-w-3xl mx-auto border border-slate-200 rounded-xl overflow-hidden shadow-lg"><div className="bg-indigo-50 p-4 border-b border-indigo-100 font-bold text-indigo-800 text-center uppercase tracking-wide text-lg">GELİR TABLOSU (DETAYLI)</div><div className="p-8 bg-white space-y-4"><div><Row label="A. BRÜT SATIŞLAR" value={incomeStatement.grossSales} bold /><IncomeExpenseDetailList prefixes={['60']} type="income" /></div><div><Row label="B. SATIŞ İNDİRİMLERİ (-)" value={incomeStatement.salesDeductions} color="text-red-500" /><IncomeExpenseDetailList prefixes={['61']} type="expense" /></div><div className="py-2 border-t border-slate-100"><Row label="NET SATIŞLAR" value={incomeStatement.netSales} bold color="text-indigo-700" /></div><div><Row label="C. SATIŞLARIN MALİYETİ (-)" value={incomeStatement.cogs} color="text-red-500" /><IncomeExpenseDetailList prefixes={['62', '71', '72', '73', '74']} type="expense" /></div><div className="py-2 border-t border-slate-100"><Row label="BRÜT SATIŞ KARI/ZARARI" value={incomeStatement.grossProfit} bold color={incomeStatement.grossProfit>=0?"text-green-600":"text-red-600"} /></div><div><Row label="D. FAALİYET GİDERLERİ (-)" value={incomeStatement.operatingExp} color="text-red-500" /><IncomeExpenseDetailList prefixes={['63', '75', '76', '77']} type="expense" /></div><div className="py-2 border-t border-slate-100"><Row label="FAALİYET KARI/ZARARI" value={incomeStatement.operatingProfit} bold color={incomeStatement.operatingProfit>=0?"text-green-600":"text-red-600"} /></div><div><Row label="E. DİĞER FAAL. OLAĞAN GELİR/KAR" value={incomeStatement.otherIncome} /><IncomeExpenseDetailList prefixes={['64']} type="income" /></div><div><Row label="F. DİĞER FAAL. OLAĞAN GİDER/ZARAR (-)" value={incomeStatement.otherExp} color="text-red-500" /><IncomeExpenseDetailList prefixes={['65']} type="expense" /></div><div><Row label="G. FİNANSMAN GİDERLERİ (-)" value={incomeStatement.financeExp} color="text-red-500" /><IncomeExpenseDetailList prefixes={['66', '78']} type="expense" /></div>
                <div><Row label="H. OLAĞANDIŞI GELİR VE KARLAR" value={incomeStatement.extraordinaryIncome} /><IncomeExpenseDetailList prefixes={['67']} type="income" /></div>
                <div><Row label="I. OLAĞANDIŞI GİDER VE ZARARLAR (-)" value={incomeStatement.extraordinaryExpense} color="text-red-500" /><IncomeExpenseDetailList prefixes={['68']} type="expense" /></div>
                <div className="mt-6 pt-4 border-t-2 border-slate-200 bg-slate-50 p-3 rounded"><Row label="DÖNEM NET KARI/ZARARI" value={incomeStatement.profitBeforeTax} bold color={incomeStatement.profitBeforeTax>=0?"text-green-700 text-xl":"text-red-700 text-xl"} /></div></div></div>
            )}
        </div>
    );
  };
  const FinancialView = () => {
      // ... financial view logic same as before ...
      if (!reportData) return <div className="p-10 text-center text-slate-500">Analiz için veri yükleyiniz.</div>;
      const { ratios, score, risks } = reportData;
  
      const check = (val, target, invert = false) => {
          if (invert) return val <= target ? 'good' : val <= target * 1.2 ? 'warning' : 'bad';
          return val >= target ? 'good' : val >= target * 0.8 ? 'warning' : 'bad';
      };
  
      return (
          <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 pb-12 print:p-0">
               <div className="flex justify-end mb-2 no-print"><button onClick={handlePrint} className="p-2 bg-slate-200 rounded hover:bg-slate-300 text-slate-600 flex gap-2 items-center"><Printer size={18}/> Yazdır</button></div>
  
              <div className="bg-gradient-to-r from-slate-900 to-slate-800 text-white p-8 rounded-3xl shadow-xl flex flex-col md:flex-row justify-between items-center relative overflow-hidden print:bg-slate-900 print:text-white print:shadow-none">
                   <div className="z-10 max-w-xl">
                      <h2 className="text-2xl font-bold mb-2 flex items-center gap-2"><Activity className="text-emerald-400"/> Finansal Sağlık Raporu</h2>
                      <p className="text-slate-400 text-sm">Yapay zeka destekli likidite, karlılık ve risk analizi.</p>
                   </div>
                   <div className="z-10 flex items-center gap-6 mt-6 md:mt-0">
                      <div className="text-right"><span className="text-xs font-bold text-slate-400 uppercase block">Genel Skor</span><span className={`text-5xl font-black tracking-tighter ${score >= 70 ? 'text-emerald-400' : score >= 50 ? 'text-amber-400' : 'text-rose-400'}`}>{score}</span></div>
                   </div>
              </div>
  
              <div>
                  <h3 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2"><Wallet size={20} className="text-blue-600"/> 1. Likidite Analizi</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                      <KpiCard title="Cari Oran" value={ratios.currentRatio.toFixed(2)} type={check(ratios.currentRatio, 1.5)} formula="Dönen Varlıklar / Kısa Vadeli Yükümlülükler" explanation={ratios.currentRatio >= 1.5 ? "Şirket kısa vadeli borçlarını rahatça ödeyebilecek varlığa sahip." : ratios.currentRatio < 1 ? "Kısa vadeli borç ödeme riski yüksek, işletme sermayesi açığı olabilir." : "Likidite sınırda, nakit akışı dikkatle yönetilmeli."} />
                      <KpiCard title="Asit-Test Oranı" value={ratios.acidTest.toFixed(2)} type={check(ratios.acidTest, 1.0)} formula="(Dönen Varlıklar - Stoklar) / K.V.Y.K." explanation={ratios.acidTest >= 1 ? "Stoklara bağımlı kalmadan borçlar ödenebilir." : "Borç ödemesi için stok satışına ihtiyaç duyuluyor, bu riskli olabilir."} />
                      <KpiCard title="Nakit Oran" value={ratios.cashRatio.toFixed(2)} type={check(ratios.cashRatio, 0.2)} formula="(Hazır Değerler + Menkul K.) / K.V.Y.K." explanation={ratios.cashRatio >= 0.2 ? "Acil nakit ihtiyacını karşılama gücü yüksek." : "Elde tutulan nakit seviyesi düşük, beklenmedik giderlere karşı kırılgan."} />
                      <div className="bg-blue-50 p-5 rounded-2xl border border-blue-100 flex flex-col justify-center relative group">
                           <div className="absolute top-3 right-3 no-print"><HelpCircle size={16} className="text-blue-300"/></div>
                           <span className="text-[10px] font-bold text-blue-400 uppercase tracking-wider">Net İşletme Sermayesi</span>
                           <span className="text-2xl font-black text-blue-700">{formatCurrency(ratios.nwc)} TL</span>
                           <div className="mt-2 text-[10px] text-blue-600 leading-tight">Dönen varlıkların kısa vadeli borçları aşan kısmı. Pozitif olması operasyonel güvenliği gösterir.</div>
                      </div>
                  </div>
              </div>
  
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                   <div className="lg:col-span-2">
                      <h3 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2"><Scale size={20} className="text-purple-600"/> 2. Mali Yapı</h3>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                          <KpiCard title="Finansal Kaldıraç" value={formatPercent(ratios.leverage)} type={check(ratios.leverage, 0.7, true)} formula="Toplam Borç / Toplam Varlık" explanation={ratios.leverage > 0.7 ? "Varlıkların büyük kısmı borçla finanse ediliyor, faiz ve geri ödeme riski yüksek." : "Şirketin borçluluk düzeyi makul, finansal bağımsızlık güçlü."} />
                          <KpiCard title="Borç / Özsermaye" value={ratios.debtToEquity.toFixed(2)} type={check(ratios.debtToEquity, 1.5, true)} formula="Toplam Borç / Özkaynaklar" explanation={ratios.debtToEquity > 1.5 ? "Borçlar özkaynakların çok üzerinde, sermaye artırımı gerekebilir." : "Ortaklar, alacaklılardan daha fazla risk üstlenmiş, yapı sağlıklı."} />
                          <div className="bg-white p-5 rounded-2xl border border-slate-100 shadow-sm">
                               <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block mb-3">Yapısal Dağılım</span>
                               <RiskGauge title="Kısa Vadeli Borç Yükü" val={ratios.shortTermDebtRate * 100} min={0} max={100} unit="%" />
                               <div className="mt-3"><RiskGauge title="Özkaynak Oranı" val={ratios.equityRatio * 100} min={0} max={100} unit="%" /></div>
                          </div>
                      </div>
                   </div>
                   <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm flex flex-col items-center justify-center">
                       <h4 className="text-xs font-bold text-slate-400 uppercase mb-4">Kaynak Dağılımı</h4>
                       <div className="relative w-32 h-32 rounded-full" style={{background: `conic-gradient(#8b5cf6 0% ${(ratios.leverage * 100)}%, #cbd5e1 ${(ratios.leverage * 100)}% 100%)`}}>
                           <div className="absolute inset-4 bg-white rounded-full flex items-center justify-center flex-col">
                               <span className="text-2xl font-black text-purple-600">{formatPercent(ratios.leverage)}</span>
                               <span className="text-[8px] font-bold text-slate-400 uppercase">Borç</span>
                           </div>
                       </div>
                   </div>
              </div>
  
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                   <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm">
                       <h3 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2"><BarChart2 size={20} className="text-emerald-600"/> 3. Karlılık Analizi</h3>
                       <div className="space-y-4">
                          {[
                              { l: "Brüt Kar Marjı", v: ratios.grossMargin, r: 0.20 },
                              { l: "FAVÖK Marjı", v: ratios.ebitdaMargin, r: 0.15 },
                              { l: "Net Kar Marjı", v: ratios.netMargin, r: 0.05 },
                              { l: "Özkaynak Karlılığı (ROE)", v: ratios.roe, r: 0.20 }
                          ].map((i, idx) => (
                               <div key={idx} className="flex justify-between items-center p-3 bg-slate-50 rounded-xl border border-slate-100">
                                  <span className="text-sm font-medium text-slate-600">{i.l}</span>
                                  <div className="flex items-center gap-3">
                                      <span className={`text-xs font-bold px-2 py-0.5 rounded ${i.v >= i.r ? 'bg-emerald-100 text-emerald-700' : 'bg-rose-100 text-rose-700'}`}>{i.v >= i.r ? 'İyi' : 'Düşük'}</span>
                                      <span className="font-bold text-slate-800 w-16 text-right">{formatPercent(i.v)}</span>
                                  </div>
                              </div>
                          ))}
                       </div>
                   </div>
  
                   <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm">
                       <h3 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2"><Activity size={20} className="text-orange-500"/> 4. Faaliyet Verimliliği</h3>
                       <div className="flex justify-around items-end mb-4">
                           <GaugeChart value={ratios.dso} max={120} label="Tahsilat" subLabel="Alacak Günü" color="#3b82f6" />
                           <GaugeChart value={ratios.dio} max={180} label="Stok" subLabel="Stok Günü" color="#f59e0b" />
                           <GaugeChart value={ratios.dpo} max={120} label="Ödeme" subLabel="Borç Günü" color="#10b981" />
                       </div>
                       <div className="bg-orange-50 p-4 rounded-xl text-center border border-orange-100">
                           <span className="text-xs font-bold text-orange-400 uppercase tracking-wider">Nakit Dönüşüm Süresi (CCC)</span>
                           <h3 className="text-3xl font-black text-orange-600 mt-1">{ratios.ccc.toFixed(0)} <span className="text-sm font-medium text-orange-400">Gün</span></h3>
                           <p className="text-[10px] text-orange-600/70 mt-1">Şirketin nakde dönme hızı. Düşük olması iyidir.</p>
                       </div>
                   </div>
              </div>
          </div>
      );
    };
  const OperationalView = () => {
      // ... operational view logic same as before ...
      if (!reportData) return <div className="p-10 text-center text-slate-500">Analiz için veri yükleyiniz.</div>;
      const { sustainability, operationalScore } = reportData;
  
      return (
          <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 pb-12 print:p-0">
              <div className="flex justify-end mb-2 no-print"><button onClick={handlePrint} className="p-2 bg-slate-200 rounded hover:bg-slate-300 text-slate-600 flex gap-2 items-center"><Printer size={18}/> Yazdır</button></div>
  
              <div className="bg-gradient-to-r from-emerald-900 to-teal-800 text-white p-6 rounded-xl shadow-lg flex flex-col md:flex-row justify-between items-center print:bg-emerald-900 print:text-white print:shadow-none">
                  <div><h2 className="text-2xl font-bold mb-1 flex items-center gap-2"><Leaf className="text-emerald-400"/> Faaliyet Sürdürülebilirlik Puanı</h2><p className="text-emerald-200 text-sm">GHG Protokolü (Sera Gazı Protokolü) standartlarına göre KOBİ emisyon analizi.</p></div>
                  <div className="mt-4 md:mt-0 flex gap-6 text-xs bg-white/10 p-3 rounded-lg backdrop-blur-md border border-white/10">
                      <div className="px-3 border-r border-white/20"><span className="block text-emerald-300 uppercase font-bold">Toplam Emisyon</span><span className="text-2xl font-black">{sustainability.total_emission.toLocaleString(undefined, {maximumFractionDigits:0})} <span className="text-sm font-medium">tCO2e</span></span></div>
                      <div className="px-3"><span className="block text-emerald-300 uppercase font-bold">Operasyonel Skor</span><span className="text-2xl font-black text-white">{operationalScore.toFixed(0)} <span className="text-xs font-medium">/ 100</span></span></div>
                  </div>
              </div>
  
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                   {SUSTAINABILITY_CATEGORIES.map(cat => {
                       const val = sustainability[cat.id];
                       if (val <= 0) return null; 
                       return (
                          <div key={cat.id} className="bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-all overflow-hidden">
                              <div className={`p-4 border-b border-slate-100 flex justify-between items-start ${cat.bg}`}>
                                  <div><div className={`p-2 rounded-lg bg-white w-fit mb-3 ${cat.color}`}><cat.icon size={20}/></div><h4 className="font-bold text-slate-800">{cat.label}</h4><span className="text-[10px] uppercase font-bold bg-white/50 px-2 py-1 rounded text-slate-600 mt-1 inline-block">{cat.scope}</span></div>
                                  <div className="text-right"><div className="text-2xl font-black text-slate-700">{formatCurrency(val)}</div><div className="text-xs text-slate-500">Harcama (TL)</div></div>
                              </div>
                              <div className="p-4 space-y-3"><div className="flex justify-between text-sm"><span className="text-slate-500">Tahmini Emisyon</span><span className="font-bold text-slate-800">{(val * cat.factor).toLocaleString(undefined, {maximumFractionDigits:0})} kgCO2e</span></div><div className="text-xs text-slate-400 italic bg-slate-50 p-2 rounded">{cat.desc}</div></div>
                          </div>
                       )
                   })}
                   {/* Kapsam Dışı / Diğer Giderler Özeti */}
                   {sustainability.other > 0 && (
                       <div className="bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-all overflow-hidden opacity-75">
                           <div className="p-4 border-b border-slate-100 flex justify-between items-start bg-slate-50">
                               <div>
                                   <div className="p-2 rounded-lg bg-slate-200 w-fit mb-3 text-slate-600"><ListFilter size={20}/></div>
                                   <h4 className="font-bold text-slate-700">Diğer / Kapsam Dışı</h4>
                                   <span className="text-[10px] uppercase font-bold bg-slate-100 px-2 py-1 rounded text-slate-500 mt-1 inline-block">Analiz Dışı</span>
                               </div>
                               <div className="text-right"><div className="text-2xl font-black text-slate-600">{formatCurrency(sustainability.other)}</div><div className="text-xs text-slate-400">Harcama (TL)</div></div>
                           </div>
                           <div className="p-4 text-xs text-slate-500 italic">Bu kalemler için standart bir emisyon faktörü eşleşmesi bulunamadı.</div>
                       </div>
                   )}
              </div>
               <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                   <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
                       <h3 className="font-bold text-slate-700 mb-4 flex items-center gap-2"><PieChart size={18}/> Emisyon Dağılımı (Kapsam Bazlı)</h3>
                       <div className="flex items-center justify-center h-64 text-slate-400 text-sm bg-slate-50 rounded-lg">
                           <div className="w-full px-8 space-y-4">
                               {SUSTAINABILITY_CATEGORIES.map(cat => {
                                   const emission = sustainability[cat.id] * cat.factor;
                                   const percent = (emission / sustainability.total_emission) * 100;
                                   if (percent < 1) return null;
                                   return (<div key={cat.id}><div className="flex justify-between text-xs mb-1"><span>{cat.label}</span><span>{percent.toFixed(1)}%</span></div><div className="w-full bg-slate-200 rounded-full h-2"><div className={`h-2 rounded-full ${cat.color.replace('text-','bg-')}`} style={{width: `${percent}%`}}></div></div></div>)
                               })}
                           </div>
                       </div>
                   </div>
                   <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
                       <h3 className="font-bold text-slate-700 mb-4 flex items-center gap-2"><Info size={18}/> Sürdürülebilirlik Notları</h3>
                       <div className="space-y-3 text-sm text-slate-600">
                           <p>📌 <strong>Kapsam 1:</strong> Doğrudan emisyonlar (doğalgaz, şirket araçları) toplamın önemli bir kısmını oluşturuyorsa, enerji verimliliği yatırımları ve rota optimizasyonu önerilir.</p>
                           <p>📌 <strong>Kapsam 2:</strong> Elektrik tüketimi, yenilenebilir enerji kaynaklarına (I-REC sertifikası vb.) geçiş ile sıfırlanabilir.</p>
                           <p>📌 <strong>Kapsam 3:</strong> Tedarik zinciri ve atık yönetimi dolaylı emisyonlardır. Tedarikçi seçiminde çevresel kriterler gözetilmelidir.</p>
                       </div>
                   </div>
               </div>
          </div>
      );
    };

  const FactorsView = () => {
      if (!expenseInventory || expenseInventory.length === 0) return <div className="p-10 text-center text-slate-500">Lütfen önce mizan verisi yükleyiniz.</div>;
      
      const totalAnalyzed = expenseInventory.reduce((acc, i) => acc + i.amount, 0);
      const totalMatched = expenseInventory.filter(i => i.isMatched).reduce((acc, i) => acc + i.amount, 0);
      const coverageRatio = totalAnalyzed > 0 ? (totalMatched / totalAnalyzed) * 100 : 0;

      return (
          <div className="space-y-8 animate-in fade-in pb-12 print:p-0">
               <div className="flex justify-end mb-2 no-print"><button onClick={handlePrint} className="p-2 bg-slate-200 rounded hover:bg-slate-300 text-slate-600 flex gap-2 items-center"><Printer size={18}/> Yazdır</button></div>

               {/* Özet Kartları */}
               <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                   <div className="bg-slate-800 text-white p-6 rounded-xl shadow-md">
                       <h4 className="text-slate-400 text-xs font-bold uppercase mb-2">Toplam Gider (740-789)</h4>
                       <span className="text-2xl font-black">{formatCurrency(totalAnalyzed)}</span>
                       <span className="text-xs text-slate-400 ml-2">TL</span>
                   </div>
                   <div className="bg-emerald-600 text-white p-6 rounded-xl shadow-md">
                       <h4 className="text-emerald-200 text-xs font-bold uppercase mb-2">Emisyon Hesplanan Tutar</h4>
                       <span className="text-2xl font-black">{formatCurrency(totalMatched)}</span>
                       <span className="text-xs text-emerald-200 ml-2">TL</span>
                       <div className="mt-2 text-xs bg-emerald-700/50 inline-block px-2 py-1 rounded">Kapsama Oranı: {coverageRatio.toFixed(1)}%</div>
                   </div>
                   <div className="bg-white border border-slate-200 p-6 rounded-xl shadow-md">
                       <h4 className="text-slate-500 text-xs font-bold uppercase mb-2">Tespit Edilen Kalem Sayısı</h4>
                       <span className="text-2xl font-black text-slate-800">{expenseInventory.length}</span>
                       <span className="text-xs text-slate-400 ml-2">Adet Hesap</span>
                   </div>
               </div>

               <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden print:border-none print:shadow-none">
                   <div className="p-6 border-b border-slate-100 bg-slate-50">
                       <h3 className="font-bold text-slate-700 mb-2 flex items-center gap-2"><ListFilter size={20} className="text-indigo-600"/> Sürdürülebilirlik Gider Envanteri</h3>
                       <p className="text-xs text-slate-500">740-789 arasındaki tüm gider hesapları taranarak, olası emisyon faktörleri ile eşleştirilmiştir. Eşleşmeyen kayıtları manuel olarak düzeltebilirsiniz.</p>
                   </div>
                   
                   <div className="overflow-x-auto">
                       <table className="w-full text-xs text-left">
                           <thead className="bg-slate-100 text-slate-600 font-semibold border-b border-slate-200">
                               <tr>
                                   <th className="p-4 w-32">Hesap Kodu</th>
                                   <th className="p-4">Hesap Adı</th>
                                   <th className="p-4 text-right">Tutar (TL)</th>
                                   <th className="p-4 w-48">Tespit Edilen Kategori</th>
                                   <th className="p-4 text-right">Referans Çarpan</th>
                                   <th className="p-4 text-right">Emisyon (kgCO2e)</th>
                               </tr>
                           </thead>
                           <tbody className="divide-y divide-slate-100">
                               {expenseInventory.map((item, idx) => (
                                   <tr key={idx} className={`hover:bg-slate-50 transition-colors ${!item.isMatched ? 'bg-rose-50/30' : ''}`}>
                                       <td className="p-4 font-mono text-slate-600 font-medium">{item.code}</td>
                                       <td className="p-4 text-slate-800">{item.name}</td>
                                       <td className="p-4 text-right font-medium text-slate-700">{formatCurrency(item.amount)}</td>
                                       <td className="p-4">
                                            {item.isMatched ? (
                                                <div className="flex items-center gap-2">
                                                    <span className={`inline-flex items-center gap-1 px-2 py-1 rounded text-[10px] font-bold uppercase ${item.scope === 'Kapsam 1' ? 'bg-orange-100 text-orange-700' : item.scope === 'Kapsam 2' ? 'bg-yellow-100 text-yellow-700' : 'bg-blue-100 text-blue-700'}`}>
                                                        {item.category}
                                                    </span>
                                                    {item.isManual && <span className="text-[10px] bg-slate-200 text-slate-600 px-1 rounded flex items-center" title="Manuel Düzenleme"><Edit3 size={10} className="mr-1"/> Manuel</span>}
                                                </div>
                                            ) : (
                                                <div className="flex items-center gap-1">
                                                    <AlertTriangle size={14} className="text-rose-400" />
                                                    <select 
                                                        className="text-xs border border-slate-300 rounded px-2 py-1 bg-white focus:ring-2 focus:ring-indigo-500 outline-none"
                                                        onChange={(e) => handleManualMatch(item.code, e.target.value)}
                                                        defaultValue=""
                                                    >
                                                        <option value="" disabled>Seçiniz...</option>
                                                        {SUSTAINABILITY_CATEGORIES.map(cat => (
                                                            <option key={cat.id} value={cat.id}>{cat.label}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            )}
                                       </td>
                                       <td className="p-4 text-right">
                                           {item.isMatched ? (
                                               <span className="font-mono text-indigo-600">{item.factor.toFixed(3)}</span>
                                           ) : (
                                               <span className="text-slate-300">-</span>
                                           )}
                                       </td>
                                       <td className="p-4 text-right">
                                           {item.isMatched ? (
                                               <span className="font-bold text-emerald-600">{item.calculatedEmission.toLocaleString(undefined, {maximumFractionDigits: 1})}</span>
                                           ) : (
                                               <span className="text-slate-300">-</span>
                                           )}
                                       </td>
                                   </tr>
                               ))}
                           </tbody>
                       </table>
                   </div>
               </div>
          </div>
      );
  };

  // --- KURGAN SAYFASI (YENİ EKLENTİ) ---
  const KurganView = () => {
      // ... Kurgan logic same as before ...
      if (!reportData) return <div className="p-10 text-center text-slate-500">Analiz için mizan verisi yükleyiniz.</div>;
      const { financials, ratios } = reportData;
  
      const isLeafNode = (code) => !mizanData.some(item => item.hesapKodu !== code && item.hesapKodu.startsWith(code + '.'));
  
      const totalForeign = financials.liabilities.total;
      const totalEquity = financials.equity;
      const isRestrictionRisk = totalForeign > totalEquity;
      
      const financingExpenses = financials.expenses.finance || 0;
      const nonDeductibleEstimate = isRestrictionRisk ? financingExpenses * 0.10 : 0; 
  
      const contra120 = mizanData
        .filter(i => i.hesapKodu.startsWith('120') && (i.alacak - i.borc) > 0 && !mizanData.some(x => x.hesapKodu.startsWith(i.hesapKodu + '.')))
        .map(i => ({ ...i, bakiye: i.alacak - i.borc }))
        .sort((a, b) => b.bakiye - a.bakiye)
        .slice(0, 5);
        
      const contra320 = mizanData
        .filter(i => i.hesapKodu.startsWith('320') && (i.borc - i.alacak) > 0 && !mizanData.some(x => x.hesapKodu.startsWith(i.hesapKodu + '.')))
        .map(i => ({ ...i, bakiye: i.borc - i.alacak }))
        .sort((a, b) => b.bakiye - a.bakiye)
        .slice(0, 5);
  
      const cashBalanceLeaf = mizanData
        .filter(item => item.hesapKodu.startsWith('100') && isLeafNode(item.hesapKodu))
        .reduce((acc, item) => acc + (item.borc - item.alacak), 0);
  
      const analyzePrepaidExpenses = (startDate, endDate) => {
          return mizanData.filter(item => {
              if (!item.hesapKodu.startsWith('180')) return false;
              if ((item.borc - item.alacak) <= 0) return false; 
              if (!isLeafNode(item.hesapKodu)) return false;
              const parenRegex = /\(([^)]+)\)/g;
              let match;
              while ((match = parenRegex.exec(item.hesapAdi)) !== null) {
                  const contentInsideParens = match[1];
                  const dateRegex = /(\d{2})\.(\d{2})\.(\d{4})/g;
                  let dateMatch;
                  while ((dateMatch = dateRegex.exec(contentInsideParens)) !== null) {
                      const [_, d, m, y] = dateMatch;
                      const dateObj = new Date(parseInt(y), parseInt(m) - 1, parseInt(d));
                      if (dateObj >= startDate && dateObj <= endDate) {
                          return true;
                      }
                  }
              }
              return false;
          }).map(item => ({
              ...item,
              bakiye: item.borc - item.alacak
          }));
      };
  
      const period1Analysis = analyzePrepaidExpenses(new Date(2025, 0, 1), new Date(2025, 8, 30));
      const totalPeriod1 = period1Analysis.reduce((acc, curr) => acc + curr.bakiye, 0);
      const period2Analysis = analyzePrepaidExpenses(new Date(2025, 9, 1), new Date(2025, 11, 31));
      const totalPeriod2 = period2Analysis.reduce((acc, curr) => acc + curr.bakiye, 0);
      
      return (
          <div className="space-y-8 animate-in fade-in pb-12">
               <div className="flex justify-end mb-2 no-print"><button onClick={handlePrint} className="p-2 bg-slate-200 rounded hover:bg-slate-300 text-slate-600 flex gap-2 items-center"><Printer size={18}/> Yazdır</button></div>
  
               <div className="bg-slate-900 text-white p-6 rounded-xl flex items-center gap-4 shadow-lg print:bg-slate-900 print:text-white">
                   <div className="p-3 bg-red-600 rounded-lg text-white"><ShieldAlert size={32} /></div>
                   <div>
                       <h2 className="text-2xl font-bold">KURGAN - Mali Güvenlik Analizi</h2>
                       <p className="text-slate-400 text-sm">Vergi Denetim Kurulu (VDK) kriterlerine göre detaylı risk taraması.</p>
                   </div>
               </div>
  
               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                   <div className={`p-6 rounded-xl border-l-8 shadow-sm bg-white ${isRestrictionRisk ? 'border-red-500' : 'border-green-500'}`}>
                       <h3 className="font-bold text-slate-700 flex items-center gap-2 mb-4"><Scale size={20}/> Finansman Gider Kısıtlaması</h3>
                       <div className="space-y-4">
                           <div className="flex justify-between text-sm">
                               <span className="text-slate-500">Yabancı Kaynaklar:</span>
                               <span className="font-bold text-slate-800">{formatCurrency(totalForeign)}</span>
                           </div>
                           <div className="flex justify-between text-sm">
                               <span className="text-slate-500">Özkaynaklar:</span>
                               <span className="font-bold text-slate-800">{formatCurrency(totalEquity)}</span>
                           </div>
                           <div className="w-full bg-slate-100 h-4 rounded-full overflow-hidden flex">
                               <div className="bg-red-400 h-full flex items-center justify-center text-[10px] text-white" style={{width: `${(totalForeign / (totalForeign + totalEquity)) * 100}%`}}>YK</div>
                               <div className="bg-green-400 h-full flex items-center justify-center text-[10px] text-white" style={{width: `${(totalEquity / (totalForeign + totalEquity)) * 100}%`}}>ÖK</div>
                           </div>
                           {isRestrictionRisk ? (
                               <div className="bg-red-50 p-3 rounded border border-red-100 text-xs text-red-800">
                                   <strong>RİSKLİ:</strong> Yabancı kaynaklar özkaynakları aştığı için, aşan kısma isabet eden finansman giderlerinin %10'u KKEG yazılmalıdır.
                                   <br/><br/>Tahmini KKEG Riski: <strong>{formatCurrency(nonDeductibleEstimate)} TL</strong>
                               </div>
                           ) : (
                               <div className="bg-green-50 p-3 rounded border border-green-100 text-xs text-green-800">
                                   <strong>GÜVENLİ:</strong> Özkaynaklar yabancı kaynaklardan fazla. Kısıtlama uygulanmaz.
                               </div>
                           )}
                       </div>
                   </div>
  
                   <div className="p-6 rounded-xl border-l-8 border-blue-500 shadow-sm bg-white">
                       <h3 className="font-bold text-slate-700 flex items-center gap-2 mb-4"><Banknote size={20}/> Kasa ve Tevsik Zorunluluğu</h3>
                       <div className="text-sm text-slate-600 space-y-3">
                           <p>
                               <span className="font-bold block text-slate-800 mb-1">Güncel Sınır: 30.000 TL</span>
                               VUK Mük. 257 uyarınca, <strong>30.000 TL</strong>'yi aşan tahsilat ve ödemelerin banka/finans kurumları aracılığıyla yapılması zorunludur.
                           </p>
                           <div className="p-3 bg-blue-50 rounded border border-blue-100 text-blue-800">
                               <div className="flex justify-between mb-1"><span>Kasa Bakiyesi (100 - En Alt Kırılım):</span> <strong>{formatCurrency(cashBalanceLeaf)}</strong></div>
                               {cashBalanceLeaf > 50000 && <span className="block mt-2 text-xs font-bold text-red-600">UYARI: Kasa bakiyesi yüksek. Adat hesaplaması gerekebilir.</span>}
                           </div>
                       </div>
                   </div>
               </div>
  
               <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
                   <h3 className="font-bold text-slate-700 flex items-center gap-2 mb-4"><ArrowUpRight size={20} className="text-amber-500"/> Ters Bakiye Veren Hesaplar (En Yüksek 5)</h3>
                   <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                       <div>
                           <h4 className="text-xs font-bold text-slate-500 uppercase mb-2 border-b pb-1">120 Alıcılar (Alacak Bakiyesi Verenler)</h4>
                           {contra120.length > 0 ? (
                               <table className="w-full text-xs">
                                   <tbody>
                                       {contra120.map(i => (
                                           <tr key={i.hesapKodu} className="border-b border-slate-50 hover:bg-slate-50">
                                               <td className="py-2 font-mono text-slate-600">{i.hesapKodu}</td>
                                               <td className="py-2 text-slate-800">{i.hesapAdi.substring(0, 30)}...</td>
                                               <td className="py-2 text-right font-bold text-red-600">{formatCurrency(i.bakiye)}</td>
                                           </tr>
                                       ))}
                                   </tbody>
                               </table>
                           ) : <div className="text-xs text-slate-400 italic">Bulunamadı.</div>}
                       </div>
                       <div>
                           <h4 className="text-xs font-bold text-slate-500 uppercase mb-2 border-b pb-1">320 Satıcılar (Borç Bakiyesi Verenler)</h4>
                           {contra320.length > 0 ? (
                               <table className="w-full text-xs">
                                   <tbody>
                                       {contra320.map(i => (
                                           <tr key={i.hesapKodu} className="border-b border-slate-50 hover:bg-slate-50">
                                               <td className="py-2 font-mono text-slate-600">{i.hesapKodu}</td>
                                               <td className="py-2 text-slate-800">{i.hesapAdi.substring(0, 30)}...</td>
                                               <td className="py-2 text-right font-bold text-emerald-600">{formatCurrency(i.bakiye)}</td>
                                           </tr>
                                       ))}
                                   </tbody>
                               </table>
                           ) : <div className="text-xs text-slate-400 italic">Bulunamadı.</div>}
                       </div>
                   </div>
               </div>
  
               <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
                   <div className="flex justify-between items-center mb-6 border-b border-slate-100 pb-4">
                       <div>
                           <h3 className="font-bold text-slate-700 flex items-center gap-2"><Clock size={20} className="text-indigo-600"/> 180 - Gelecek Aylara Ait Giderler (Dönemsellik Analizi)</h3>
                           <p className="text-xs text-slate-500 mt-1">Hesap açıklamasındaki parantez içi tarihlerin (01.01.2025 - 31.12.2025) taranması sonucu elde edilen bulgular.</p>
                       </div>
                   </div>
  
                   <div className={`mb-8 p-4 rounded-xl border ${period1Analysis.length > 0 ? 'bg-orange-50 border-orange-200' : 'bg-slate-50 border-slate-100'}`}>
                        <div className="flex justify-between items-end mb-3">
                            <div>
                                <h4 className="font-bold text-sm text-slate-800 flex items-center gap-2">
                                    {period1Analysis.length > 0 ? <AlertTriangle size={16} className="text-orange-600"/> : <CheckCircle size={16} className="text-emerald-600"/>}
                                    Dönem İçi Giderleşmesi Gerekenler (01.01.2025 - 30.09.2025)
                                </h4>
                                <p className="text-[10px] text-slate-500 mt-1">Bu aralıktaki tutarların 7xx hesaplarına virmanlanması beklenir.</p>
                            </div>
                            {period1Analysis.length > 0 && (
                                <span className="text-lg font-black text-orange-700 bg-white px-2 py-1 rounded shadow-sm border border-orange-100">
                                    {formatCurrency(totalPeriod1)}
                                </span>
                            )}
                        </div>
  
                        {period1Analysis.length > 0 ? (
                            <table className="w-full text-xs text-left bg-white rounded-lg overflow-hidden">
                                <thead className="bg-orange-100 text-orange-800 font-semibold">
                                    <tr>
                                        <th className="p-2">Kod</th>
                                        <th className="p-2">Hesap Adı</th>
                                        <th className="p-2 text-right">Bakiye</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-orange-50">
                                    {period1Analysis.map((item, idx) => (
                                        <tr key={idx} className="hover:bg-orange-50/50">
                                            <td className="p-2 font-mono text-slate-600">{item.hesapKodu}</td>
                                            <td className="p-2 text-slate-800">{item.hesapAdi}</td>
                                            <td className="p-2 text-right font-bold text-orange-600">{formatCurrency(item.bakiye)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <div className="text-xs text-emerald-600 italic font-medium">Bu dönem için açıkta kalan gider hesabı tespit edilmedi.</div>
                        )}
                   </div>
  
                   <div className={`p-4 rounded-xl border ${period2Analysis.length > 0 ? 'bg-blue-50 border-blue-200' : 'bg-slate-50 border-slate-100'}`}>
                        <div className="flex justify-between items-end mb-3">
                            <div>
                                <h4 className="font-bold text-sm text-slate-800 flex items-center gap-2">
                                    <Info size={16} className="text-blue-600"/>
                                    Yıl Sonu Dönemi İçin Bekleyenler (01.10.2025 - 31.12.2025)
                                </h4>
                                <p className="text-[10px] text-slate-500 mt-1">Yıl sonuna kadar giderleşecek olan potansiyel tutarlar.</p>
                            </div>
                            {period2Analysis.length > 0 && (
                                <span className="text-lg font-black text-blue-700 bg-white px-2 py-1 rounded shadow-sm border border-blue-100">
                                    {formatCurrency(totalPeriod2)}
                                </span>
                            )}
                        </div>
  
                        {period2Analysis.length > 0 ? (
                            <table className="w-full text-xs text-left bg-white rounded-lg overflow-hidden">
                                <thead className="bg-blue-100 text-blue-800 font-semibold">
                                    <tr>
                                        <th className="p-2">Kod</th>
                                        <th className="p-2">Hesap Adı</th>
                                        <th className="p-2 text-right">Bakiye</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-blue-50">
                                    {period2Analysis.map((item, idx) => (
                                        <tr key={idx} className="hover:bg-blue-50/50">
                                            <td className="p-2 font-mono text-slate-600">{item.hesapKodu}</td>
                                            <td className="p-2 text-slate-800">{item.hesapAdi}</td>
                                            <td className="p-2 text-right font-bold text-blue-600">{formatCurrency(item.bakiye)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <div className="text-xs text-slate-400 italic font-medium">Bu dönem aralığına ait kayıt bulunamadı.</div>
                        )}
                   </div>
               </div>
          </div>
      );
  };

  // --- ENTEGRE RAPOR SAYFASI (FİNAL) ---
  const IntegratedReportView = () => {
      // ... Integrated Report view logic same as before ...
      if (!reportData) return null;
      const { sustainability, ratios, score } = reportData;
  
      const scope1Total = SUSTAINABILITY_CATEGORIES.filter(c => c.scope.includes('Kapsam 1')).reduce((acc, curr) => acc + (sustainability[curr.id] * curr.factor), 0);
      const scope2Total = SUSTAINABILITY_CATEGORIES.filter(c => c.scope.includes('Kapsam 2')).reduce((acc, curr) => acc + (sustainability[curr.id] * curr.factor), 0);
      const scope3Total = SUSTAINABILITY_CATEGORIES.filter(c => c.scope.includes('Kapsam 3')).reduce((acc, curr) => acc + (sustainability[curr.id] * curr.factor), 0);
  
      return (
          <div className="bg-white w-[210mm] min-h-[297mm] mx-auto p-10 shadow-2xl text-slate-800 text-sm print:shadow-none print:w-full relative print:m-0 print:p-8">
              {/* ... Header, Score etc ... */}
              <style>{`
                @media print {
                    @page { margin: 0; size: A4; }
                    body { -webkit-print-color-adjust: exact; print-color-adjust: exact; background: white; }
                    .no-print { display: none !important; }
                    .print-break-inside-avoid { break-inside: avoid; }
                    .print-container { width: 100%; max-width: 210mm; margin: 0; padding: 10mm; box-shadow: none; }
                }
            `}</style>
            
            <button onClick={handlePrint} className="absolute top-4 right-4 p-2 bg-slate-800 text-white rounded-full shadow-lg hover:bg-slate-700 print:hidden transition-all no-print"><Printer size={20}/></button>

            {/* HEADER & ESG SCORE */}
            <div className="mb-8 text-center print-break-inside-avoid">
                 <div className="inline-block border-b-2 border-emerald-500 pb-2 mb-4">
                    <h1 className="text-3xl font-black tracking-tight uppercase text-slate-900">Entegre Sürdürülebilirlik Raporu</h1>
                    <p className="text-slate-400 text-xs uppercase tracking-widest">KOBİ Sürüm Düzey-1 Analiz | {new Date().toLocaleDateString('tr-TR')}</p>
                 </div>
                 
                 <div className="bg-white border-4 border-double border-slate-100 rounded-3xl p-6 max-w-lg mx-auto shadow-sm flex items-center justify-center gap-6">
                     <div className="relative w-32 h-32 flex items-center justify-center">
                         <svg className="w-full h-full transform -rotate-90">
                             <circle cx="64" cy="64" r="56" stroke="#f1f5f9" strokeWidth="12" fill="none" />
                             <circle cx="64" cy="64" r="56" stroke={score >= 70 ? "#10b981" : score >= 50 ? "#f59e0b" : "#e11d48"} strokeWidth="12" fill="none" strokeDasharray="351" strokeDashoffset={351 - (351 * score) / 100} strokeLinecap="round" />
                         </svg>
                         <div className="absolute inset-0 flex flex-col items-center justify-center">
                             <span className={`text-4xl font-black ${score >= 70 ? "text-emerald-600" : score >= 50 ? "text-amber-500" : "text-rose-600"}`}>{score}</span>
                         </div>
                     </div>
                     <div className="text-left">
                         <h2 className="text-2xl font-bold text-slate-800">Sürdürülebilirlik Skoru</h2>
                         <p className="text-xs text-slate-500 mt-1 max-w-[200px]">Finansal güç, karbon verimliliği ve yönetişim uyumunun bileşkesi.</p>
                         <span className={`inline-block mt-2 text-xs font-bold px-2 py-1 rounded ${score >= 70 ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`}>{score >= 70 ? 'Yüksek Performans' : 'Gelişime Açık'}</span>
                     </div>
                 </div>
            </div>

            <div className="mb-8 p-4 bg-slate-50 rounded-xl border-l-4 border-green-500 text-slate-600 text-xs leading-relaxed print-break-inside-avoid">
                <strong className="text-green-700 block mb-1 uppercase">ESG Skor Değerlendirmesi</strong>
                Bu skor; firmanızın <strong>Finansal Dayanıklılığı (%40)</strong>, <strong>Karbon Yoğunluğu (%40)</strong> ve <strong>Yönetişim Uyumu (%20)</strong> baz alınarak hesaplanmıştır. 
                {score >= 70 ? " Yüksek skor, sürdürülebilir büyüme potansiyelinizin güçlü olduğunu gösterir." : " Skorunuz geliştirilmeye açıktır, aşağıdaki aksiyon planlarını inceleyiniz."}
            </div>

            <div className="grid grid-cols-3 gap-8 mb-8">
                {/* SOL KOLON: FİNANSAL ÖZET */}
                <div className="col-span-1 space-y-6 border-r border-slate-100 pr-6 print-break-inside-avoid">
                    <h3 className="font-bold text-lg flex items-center gap-2 text-indigo-700 border-b border-indigo-100 pb-2"><Wallet size={18}/> Finansal Görünüm</h3>
                    
                    <div className="space-y-4">
                        <div className="bg-white border border-slate-200 p-3 rounded-lg shadow-sm">
                            <span className="text-[10px] font-bold text-slate-400 uppercase block">Cari Oran</span>
                            <span className="text-xl font-black text-slate-800">{ratios.currentRatio.toFixed(2)}</span>
                            <span className={`text-[10px] block mt-1 font-bold ${ratios.currentRatio>=1.2?'text-emerald-600':'text-rose-600'}`}>{ratios.currentRatio>=1.2?'GÜÇLÜ LİKİDİTE':'RİSKLİ SEVİYE'}</span>
                        </div>
                        <div className="bg-white border border-slate-200 p-3 rounded-lg shadow-sm">
                            <span className="text-[10px] font-bold text-slate-400 uppercase block">Borçlanma Oranı</span>
                            <span className="text-xl font-black text-slate-800">{formatPercent(ratios.leverage)}</span>
                            <span className={`text-[10px] block mt-1 font-bold ${ratios.leverage<=0.7?'text-emerald-600':'text-rose-600'}`}>{ratios.leverage<=0.7?'DENGELİ':'YÜKSEK BORÇ'}</span>
                        </div>
                        <div className="bg-white border border-slate-200 p-3 rounded-lg shadow-sm">
                            <span className="text-[10px] font-bold text-slate-400 uppercase block">Karlılık (Net)</span>
                            <span className="text-xl font-black text-slate-800">{formatPercent(ratios.netMargin)}</span>
                        </div>
                    </div>

                    <div className="p-4 bg-indigo-50 rounded-xl border border-indigo-100 text-xs text-indigo-800 leading-relaxed">
                        <strong>Finansal Özet:</strong> Şirket, kısa vadeli yükümlülüklerini {ratios.currentRatio >= 1.2 ? 'sorunsuz' : 'zorlanarak'} karşılıyor. Sermaye yapısında {ratios.leverage > 0.7 ? 'yabancı kaynak ağırlıklı' : 'özkaynak dengeli'} bir model izleniyor.
                    </div>
                </div>

                {/* SAĞ KOLON: ÇEVRESEL ETKİ (SIRALI KAPSAMLAR) */}
                <div className="col-span-2 space-y-6 print-break-inside-avoid">
                    <h3 className="font-bold text-lg flex items-center gap-2 text-emerald-700 border-b border-emerald-100 pb-2"><Leaf size={18}/> Çevresel Etki Analizi</h3>
                    
                    {/* KAPSAM 1 */}
                    <div className="border border-slate-200 p-4 rounded-xl bg-orange-50/30">
                        <div className="flex justify-between items-center mb-2">
                            <div className="flex items-center gap-2 text-orange-700 font-bold text-sm uppercase"><Factory size={16}/> Kapsam 1 (Doğrudan)</div>
                            <div className="text-xl font-black text-slate-800">{scope1Total.toLocaleString(undefined, {maximumFractionDigits:0})} <span className="text-xs font-normal text-slate-400">kgCO2e</span></div>
                        </div>
                        <div className="text-xs text-slate-500">Isınma ve şirket araçlarından kaynaklanan doğrudan emisyonlar.</div>
                    </div>

                    {/* KAPSAM 2 */}
                    <div className="border border-slate-200 p-4 rounded-xl bg-yellow-50/30">
                        <div className="flex justify-between items-center mb-2">
                            <div className="flex items-center gap-2 text-yellow-700 font-bold text-sm uppercase"><Zap size={16}/> Kapsam 2 (Enerji)</div>
                            <div className="text-xl font-black text-slate-800">{scope2Total.toLocaleString(undefined, {maximumFractionDigits:0})} <span className="text-xs font-normal text-slate-400">kgCO2e</span></div>
                        </div>
                        <div className="text-xs text-slate-500">Satın alınan elektrik tüketiminden kaynaklanan dolaylı emisyonlar.</div>
                    </div>

                    {/* KAPSAM 3 (DETAYLI TABLO) */}
                    <div className="border border-slate-200 p-4 rounded-xl bg-blue-50/30">
                        <div className="flex justify-between items-center mb-4">
                            <div className="flex items-center gap-2 text-blue-700 font-bold text-sm uppercase"><Recycle size={16}/> Kapsam 3 (Dolaylı Zincir)</div>
                            <div className="text-xl font-black text-slate-800">{scope3Total.toLocaleString(undefined, {maximumFractionDigits:0})} <span className="text-xs font-normal text-slate-400">kgCO2e</span></div>
                        </div>
                        
                        {/* Detay Tablosu */}
                        <div className="overflow-hidden rounded-lg border border-slate-200 bg-white">
                            <table className="w-full text-xs text-left">
                                <thead className="bg-slate-100 text-slate-600 font-semibold">
                                    <tr>
                                        <th className="p-2">Kategori</th>
                                        <th className="p-2 text-right">Harcama (TL)</th>
                                        <th className="p-2 text-right">Emisyon (kg)</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-slate-100">
                                    {SUSTAINABILITY_CATEGORIES.filter(c => c.scope.includes('Kapsam 3') && sustainability[c.id] > 0).map(cat => (
                                        <tr key={cat.id}>
                                            <td className="p-2 text-slate-700">{cat.label}</td>
                                            <td className="p-2 text-right text-slate-500">{formatCurrency(sustainability[cat.id])}</td>
                                            <td className="p-2 text-right font-bold text-blue-600">{(sustainability[cat.id] * cat.factor).toLocaleString(undefined, {maximumFractionDigits:0})}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            
             {/* AI STRATEGY */}
            <div className="mt-4 pt-6 border-t-2 border-slate-100">
                <h3 className="font-bold text-lg flex items-center gap-2 text-slate-800 mb-4"><Bot size={18} className="text-purple-600"/> Yönetici Özeti ve Stratejik Tavsiyeler</h3>
                {aiReport ? (
                    <div className="prose prose-sm max-w-none text-slate-700 text-justify leading-relaxed font-medium">
                        <div className="whitespace-pre-wrap">{aiReport}</div>
                    </div>
                ) : (
                    <div className="text-center p-4 text-slate-400 italic">Analiz yükleniyor...</div>
                )}
            </div>

            {/* FOOTER */}
            <div className="mt-12 pt-4 border-t border-slate-200 flex justify-between text-[10px] text-slate-400 uppercase tracking-widest print:fixed print:bottom-4 print:left-8 print:right-8">
                <span>Yeşil | Denetim &copy; 2025</span>
                <span>Bu rapor yapay zeka destekli otomatik analiz sistemleri ile oluşturulmuştur.</span>
            </div>
          </div>
      );
  };
  
  // ... main render logic same as before ...
  return (
    <div className="min-h-screen bg-slate-50 font-sans print:bg-white">
      {/* Global Print Styles */}
      <style>{`
        @media print {
            @page { margin: 0; size: A4; }
            body { background: white; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
            .no-print { display: none !important; }
            .print-break-inside-avoid { break-inside: avoid; }
            .print-container { width: 100%; max-width: 210mm; margin: 0; padding: 10mm; box-shadow: none; }
        }
      `}</style>
      
      <header className="bg-white border-b border-slate-200 sticky top-0 z-30 px-6 py-4 flex items-center justify-between shadow-sm print:hidden">
        <div className="flex items-center gap-3">
            {/* Özel Logo Çizimi - Yüklenen logoya benzer soyut şekil */}
            <div className="w-10 h-10 relative flex-shrink-0">
                <svg viewBox="0 0 32 32" className="w-full h-full drop-shadow-sm">
                    <circle cx="11" cy="11" r="9" className="fill-teal-700" style={{opacity: 0.8, mixBlendMode: 'multiply'}} />
                    <circle cx="21" cy="11" r="9" className="fill-emerald-500" style={{opacity: 0.8, mixBlendMode: 'multiply'}} />
                    <circle cx="16" cy="21" r="9" className="fill-emerald-300" style={{opacity: 0.9, mixBlendMode: 'multiply'}} />
                </svg>
            </div>
            <h1 className="text-xl font-bold text-slate-900 tracking-tight"><span className="text-emerald-600">Yeşil</span> | Denetim</h1>
        </div>
        <nav className="hidden md:flex gap-1 bg-slate-100 p-1 rounded-lg">
            {['upload', 'mizan', 'statements', 'financial', 'operational', 'factors', 'report', 'kurgan'].map((tab) => (
                <button key={tab} onClick={() => setActiveTab(tab)} className={`px-4 py-2 text-sm font-medium rounded-md transition-all capitalize ${activeTab === tab ? 'bg-white text-indigo-600 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`}>
                    {tab === 'upload' ? 'Veri Yükle' : tab === 'mizan' ? 'Mizan' : tab === 'statements' ? 'Mali Tablolar' : tab === 'financial' ? 'Finansal' : tab === 'operational' ? 'Faaliyet' : tab === 'factors' ? 'Emisyon Envanteri' : tab === 'report' ? 'Entegre Rapor' : 'KURGAN'}
                </button>
            ))}
        </nav>
      </header>
      <main className="max-w-7xl mx-auto p-6 md:p-8 print:p-0 print:w-full print:max-w-none">
        {activeTab === 'upload' && (
            <div className="flex flex-col items-center justify-center h-[60vh] space-y-6">
                <div className="text-center max-w-lg"><h2 className="text-2xl font-bold text-slate-800 mb-2">Mizan Yükleme</h2><p className="text-slate-500">Mizan (CSV) dosyanızı yükleyin.</p></div>
                <label className={`flex flex-col items-center gap-4 p-12 border-2 border-dashed ${fileName ? 'border-green-400 bg-green-50' : 'border-slate-800 bg-white hover:border-emerald-600 hover:bg-slate-50'} rounded-2xl cursor-pointer transition-all w-full max-w-xl`}>
                    {isLoading ? <Loader2 size={48} className="animate-spin text-slate-800"/> : fileName ? <CheckCircle size={48} className="text-emerald-600"/> : <FileSpreadsheet size={48} className="text-slate-800"/>}
                    <div className="text-center"><span className="font-bold text-slate-800 text-lg block mb-1">{fileName ? 'Dosya Hazır' : 'CSV Sürükle'}</span></div>
                    <input type="file" accept=".csv" onChange={handleFileUpload} disabled={isLoading} className="hidden" />
                </label>
            </div>
        )}
        {activeTab === 'mizan' && <MizanView />}
        {activeTab === 'statements' && <StatementsView />}
        {activeTab === 'financial' && <FinancialView />}
        {activeTab === 'operational' && <OperationalView />}
        {activeTab === 'factors' && <FactorsView />}
        {activeTab === 'report' && <IntegratedReportView />}
        {activeTab === 'kurgan' && <KurganView />}
      </main>
      {reportData && !showChat && (
        <button onClick={() => setShowChat(true)} className="fixed bottom-6 right-6 bg-indigo-600 text-white p-4 rounded-full shadow-xl hover:bg-indigo-700 transition-all flex items-center gap-2 z-50 print:hidden"><Bot size={24}/></button>
      )}
      {showChat && (
        <div className="fixed bottom-6 right-6 w-80 bg-white rounded-xl shadow-2xl border border-slate-200 flex flex-col h-96 animate-in slide-in-from-bottom-4 z-50 print:hidden">
            <div className="p-3 bg-indigo-600 text-white rounded-t-xl flex justify-between items-center"><span className="font-bold text-sm">Asistan</span><button onClick={() => setShowChat(false)}><X size={16}/></button></div>
            <div className="flex-1 overflow-y-auto p-3 space-y-3 bg-slate-50">
                {chatHistory.map((msg, i) => <div key={i} className={`p-2 rounded-lg text-xs max-w-[85%] ${msg.role === 'user' ? 'bg-indigo-600 text-white ml-auto' : 'bg-white border text-slate-700'}`}>{msg.text}</div>)}
                {isChatLoading && <Loader2 size={16} className="animate-spin text-indigo-600"/>}
                <div ref={chatEndRef} />
            </div>
            <div className="p-2 border-t flex gap-2">
                <input className="flex-1 border rounded px-2 py-1 text-xs outline-none" placeholder="Sorun..." value={chatMessage} onChange={e => setChatMessage(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleChat()}/>
                <button onClick={handleChat} className="bg-indigo-600 text-white p-1.5 rounded"><Send size={14}/></button>
            </div>
        </div>
      )}
    </div>
  );
};

export default App;